/**
 * TokenCard Component Translations
 * 
 * All translations for the TokenCard component across all supported languages.
 */

export const tokenCardTranslations = {
  en: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Error loading prepaid card',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Unable to load prepaid card details. You can try again later.',
    'tokenCard.toast.copiedToClipboard': 'Copied to clipboard!',
    'tokenCard.toast.copyManually': 'Copy manually',
    'tokenCard.toast.copyManuallyDesc': 'Please copy this code: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Refreshing token status...',
    'tokenCard.toast.checkingActivity': 'Checking for recent activity',
    'tokenCard.toast.prepaidCardIssued': 'Prepaid Card Issued!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Token {{key}} has been converted to a {{brand}} prepaid card',
    'tokenCard.toast.sharedSuccessfully': 'Shared successfully!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token shared via device sharing options',
    'tokenCard.toast.shareTextCopied': 'Share text copied!',
    'tokenCard.toast.shareTextCopiedDesc': 'Token share information copied to clipboard',
    'tokenCard.toast.tokenInfoCopied': 'Share text copied!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Token information copied to clipboard',
    'tokenCard.toast.nfcPaymentReady': 'NFC Payment Ready',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Hold your phone near the payment terminal to complete the transaction.',
    'tokenCard.toast.conditionsApplied': 'Conditions Applied',
    'tokenCard.toast.conditionsAppliedDesc': 'Your token has been updated with the specified conditions.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Invoice Paid Successfully!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Invoice {{key}} has been paid.',
    'tokenCard.toast.paymentFailed': 'Payment Failed',
    'tokenCard.toast.paymentFailedDesc': 'Failed to pay invoice. Please try again.',
  },
  es: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Error al cargar tarjeta prepagada',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'No se pudieron cargar los detalles de la tarjeta prepagada. Puedes intentar de nuevo más tarde.',
    'tokenCard.toast.copiedToClipboard': '¡Copiado al portapapeles!',
    'tokenCard.toast.copyManually': 'Copiar manualmente',
    'tokenCard.toast.copyManuallyDesc': 'Por favor copia este código: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Actualizando estado del token...',
    'tokenCard.toast.checkingActivity': 'Verificando actividad reciente',
    'tokenCard.toast.prepaidCardIssued': '¡Tarjeta Prepagada Emitida!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'El token {{key}} ha sido convertido a una tarjeta prepagada {{brand}}',
    'tokenCard.toast.sharedSuccessfully': '¡Compartido exitosamente!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token compartido mediante opciones de compartir del dispositivo',
    'tokenCard.toast.shareTextCopied': '¡Texto compartido copiado!',
    'tokenCard.toast.shareTextCopiedDesc': 'Información de compartir token copiada al portapapeles',
    'tokenCard.toast.tokenInfoCopied': '¡Texto compartido copiado!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Información del token copiada al portapapeles',
    'tokenCard.toast.nfcPaymentReady': 'Pago NFC Listo',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Mantén tu teléfono cerca del terminal de pago para completar la transacción.',
    'tokenCard.toast.conditionsApplied': 'Condiciones Aplicadas',
    'tokenCard.toast.conditionsAppliedDesc': 'Tu token ha sido actualizado con las condiciones especificadas.',
    'tokenCard.toast.invoicePaidSuccessfully': '¡Factura Pagada Exitosamente!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'La factura {{key}} ha sido pagada.',
    'tokenCard.toast.paymentFailed': 'Pago Fallido',
    'tokenCard.toast.paymentFailedDesc': 'No se pudo pagar la factura. Por favor intenta de nuevo.',
  },
  fr: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Erreur lors du chargement de la carte prépayée',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Impossible de charger les détails de la carte prépayée. Vous pouvez réessayer plus tard.',
    'tokenCard.toast.copiedToClipboard': 'Copié dans le presse-papiers !',
    'tokenCard.toast.copyManually': 'Copier manuellement',
    'tokenCard.toast.copyManuallyDesc': 'Veuillez copier ce code : {{text}}',
    'tokenCard.toast.refreshingStatus': 'Actualisation du statut du token...',
    'tokenCard.toast.checkingActivity': 'Vérification de l\'activité récente',
    'tokenCard.toast.prepaidCardIssued': 'Carte prépayée émise !',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Le token {{key}} a été converti en carte prépayée {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Partagé avec succès !',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token partagé via les options de partage de l\'appareil',
    'tokenCard.toast.shareTextCopied': 'Texte de partage copié !',
    'tokenCard.toast.shareTextCopiedDesc': 'Informations de partage du token copiées dans le presse-papiers',
    'tokenCard.toast.tokenInfoCopied': 'Texte de partage copié !',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Informations du token copiées dans le presse-papiers',
    'tokenCard.toast.nfcPaymentReady': 'Paiement NFC prêt',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Tenez votre téléphone près du terminal de paiement pour compléter la transaction.',
    'tokenCard.toast.conditionsApplied': 'Conditions appliquées',
    'tokenCard.toast.conditionsAppliedDesc': 'Votre token a été mis à jour avec les conditions spécifiées.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Facture payée avec succès !',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'La facture {{key}} a été payée.',
    'tokenCard.toast.paymentFailed': 'Paiement échoué',
    'tokenCard.toast.paymentFailedDesc': 'Échec du paiement de la facture. Veuillez réessayer.',
  },
  sq: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Gabim në ngarkimin e kartës parapagimi',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Nuk mund të ngarkohen detajet e kartës parapagimi. Mund të provoni përsëri më vonë.',
    'tokenCard.toast.copiedToClipboard': 'Kopjuar në clipboard!',
    'tokenCard.toast.copyManually': 'Kopjo manualisht',
    'tokenCard.toast.copyManuallyDesc': 'Ju lutemi kopjoni këtë kod: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Duke rifreskuar statusin e tokenit...',
    'tokenCard.toast.checkingActivity': 'Duke kontrolluar aktivitetin e fundit',
    'tokenCard.toast.prepaidCardIssued': 'Karta Parapagimi e Emetuar!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Tokeni {{key}} është konvertuar në një kartë parapagimi {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Ndarë me sukses!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Tokeni u nda përmes opsioneve të ndarjes së pajisjes',
    'tokenCard.toast.shareTextCopied': 'Teksti i ndarjes u kopjua!',
    'tokenCard.toast.shareTextCopiedDesc': 'Informacioni i ndarjes së tokenit u kopjua në clipboard',
    'tokenCard.toast.tokenInfoCopied': 'Teksti i ndarjes u kopjua!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Informacioni i tokenit u kopjua në clipboard',
    'tokenCard.toast.nfcPaymentReady': 'Pagesa NFC Gati',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Mbajeni telefonin pranë terminalit të pagesës për të përfunduar transaksionin.',
    'tokenCard.toast.conditionsApplied': 'Kushtet e Aplikuara',
    'tokenCard.toast.conditionsAppliedDesc': 'Tokeni juaj është përditësuar me kushtet e specifikuara.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Fatura u Pagua me Sukses!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Fatura {{key}} është paguar.',
    'tokenCard.toast.paymentFailed': 'Pagesa Dështoi',
    'tokenCard.toast.paymentFailedDesc': 'Dështoi pagesa e faturës. Ju lutemi provoni përsëri.',
  },
  ru: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Ошибка загрузки предоплаченной карты',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Не удалось загрузить детали предоплаченной карты. Вы можете попробовать позже.',
    'tokenCard.toast.copiedToClipboard': 'Скопировано в буфер обмена!',
    'tokenCard.toast.copyManually': 'Скопировать вручную',
    'tokenCard.toast.copyManuallyDesc': 'Пожалуйста, скопируйте этот код: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Обновление статуса токена...',
    'tokenCard.toast.checkingActivity': 'Проверка недавней активности',
    'tokenCard.toast.prepaidCardIssued': 'Предоплаченная карта выпущена!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Токен {{key}} был преобразован в предоплаченную карту {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Успешно поделились!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Токен поделен через опции обмена устройства',
    'tokenCard.toast.shareTextCopied': 'Текст для обмена скопирован!',
    'tokenCard.toast.shareTextCopiedDesc': 'Информация для обмена токеном скопирована в буфер обмена',
    'tokenCard.toast.tokenInfoCopied': 'Текст для обмена скопирован!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Информация о токене скопирована в буфер обмена',
    'tokenCard.toast.nfcPaymentReady': 'NFC платеж готов',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Держите телефон рядом с платежным терминалом для завершения транзакции.',
    'tokenCard.toast.conditionsApplied': 'Условия применены',
    'tokenCard.toast.conditionsAppliedDesc': 'Ваш токен был обновлен с указанными условиями.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Счет успешно оплачен!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Счет {{key}} был оплачен.',
    'tokenCard.toast.paymentFailed': 'Платеж не удался',
    'tokenCard.toast.paymentFailedDesc': 'Не удалось оплатить счет. Пожалуйста, попробуйте снова.',
  },
  de: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Fehler beim Laden der Prepaid-Karte',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Prepaid-Kartendetails konnten nicht geladen werden. Sie können es später erneut versuchen.',
    'tokenCard.toast.copiedToClipboard': 'In die Zwischenablage kopiert!',
    'tokenCard.toast.copyManually': 'Manuell kopieren',
    'tokenCard.toast.copyManuallyDesc': 'Bitte kopieren Sie diesen Code: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Token-Status wird aktualisiert...',
    'tokenCard.toast.checkingActivity': 'Überprüfung auf kürzliche Aktivität',
    'tokenCard.toast.prepaidCardIssued': 'Prepaid-Karte ausgegeben!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Token {{key}} wurde in eine {{brand}} Prepaid-Karte umgewandelt',
    'tokenCard.toast.sharedSuccessfully': 'Erfolgreich geteilt!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token über Geräte-Sharing-Optionen geteilt',
    'tokenCard.toast.shareTextCopied': 'Share-Text kopiert!',
    'tokenCard.toast.shareTextCopiedDesc': 'Token-Share-Informationen in die Zwischenablage kopiert',
    'tokenCard.toast.tokenInfoCopied': 'Share-Text kopiert!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Token-Informationen in die Zwischenablage kopiert',
    'tokenCard.toast.nfcPaymentReady': 'NFC-Zahlung bereit',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Halten Sie Ihr Telefon in die Nähe des Zahlungsterminals, um die Transaktion abzuschließen.',
    'tokenCard.toast.conditionsApplied': 'Bedingungen angewendet',
    'tokenCard.toast.conditionsAppliedDesc': 'Ihr Token wurde mit den angegebenen Bedingungen aktualisiert.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Rechnung erfolgreich bezahlt!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Rechnung {{key}} wurde bezahlt.',
    'tokenCard.toast.paymentFailed': 'Zahlung fehlgeschlagen',
    'tokenCard.toast.paymentFailedDesc': 'Rechnung konnte nicht bezahlt werden. Bitte versuchen Sie es erneut.',
  },
  sr: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Грешка при учитавању предплаћене картице',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Не могу се учитати детаљи предплаћене картице. Можете покушати касније.',
    'tokenCard.toast.copiedToClipboard': 'Копирано у clipboard!',
    'tokenCard.toast.copyManually': 'Копирај ручно',
    'tokenCard.toast.copyManuallyDesc': 'Молимо копирајте овај код: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Освежавање статуса токена...',
    'tokenCard.toast.checkingActivity': 'Провера недавне активности',
    'tokenCard.toast.prepaidCardIssued': 'Предплаћена картица издата!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Токен {{key}} је претворен у предплаћену картицу {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Успешно подељено!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Токен подељен преко опција дељења уређаја',
    'tokenCard.toast.shareTextCopied': 'Текст за дељење копиран!',
    'tokenCard.toast.shareTextCopiedDesc': 'Информације о дељењу токена копиране у clipboard',
    'tokenCard.toast.tokenInfoCopied': 'Текст за дељење копиран!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Информације о токену копиране у clipboard',
    'tokenCard.toast.nfcPaymentReady': 'NFC плаћање спремно',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Држите телефон близу терминала за плаћање да завршите трансакцију.',
    'tokenCard.toast.conditionsApplied': 'Услови применени',
    'tokenCard.toast.conditionsAppliedDesc': 'Ваш токен је ажуриран са наведеним условима.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Фактура успешно плаћена!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Фактура {{key}} је плаћена.',
    'tokenCard.toast.paymentFailed': 'Плаћање неуспешно',
    'tokenCard.toast.paymentFailedDesc': 'Неуспешно плаћање фактуре. Молимо покушајте поново.',
  },
  pl: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Błąd ładowania karty przedpłaconej',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Nie można załadować szczegółów karty przedpłaconej. Możesz spróbować ponownie później.',
    'tokenCard.toast.copiedToClipboard': 'Skopiowano do schowka!',
    'tokenCard.toast.copyManually': 'Skopiuj ręcznie',
    'tokenCard.toast.copyManuallyDesc': 'Proszę skopiować ten kod: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Odświeżanie statusu tokena...',
    'tokenCard.toast.checkingActivity': 'Sprawdzanie ostatniej aktywności',
    'tokenCard.toast.prepaidCardIssued': 'Karta przedpłacona wydana!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Token {{key}} został przekonwertowany na kartę przedpłaconą {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Udostępniono pomyślnie!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token udostępniony przez opcje udostępniania urządzenia',
    'tokenCard.toast.shareTextCopied': 'Tekst udostępniania skopiowany!',
    'tokenCard.toast.shareTextCopiedDesc': 'Informacje o udostępnianiu tokena skopiowane do schowka',
    'tokenCard.toast.tokenInfoCopied': 'Tekst udostępniania skopiowany!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Informacje o tokenie skopiowane do schowka',
    'tokenCard.toast.nfcPaymentReady': 'Płatność NFC gotowa',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Przytrzymaj telefon przy terminalu płatniczym, aby zakończyć transakcję.',
    'tokenCard.toast.conditionsApplied': 'Warunki zastosowane',
    'tokenCard.toast.conditionsAppliedDesc': 'Twój token został zaktualizowany z określonymi warunkami.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Faktura opłacona pomyślnie!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Faktura {{key}} została opłacona.',
    'tokenCard.toast.paymentFailed': 'Płatność nie powiodła się',
    'tokenCard.toast.paymentFailedDesc': 'Nie udało się opłacić faktury. Proszę spróbować ponownie.',
  },
  el: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Σφάλμα φόρτωσης προπληρωμένης κάρτας',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Δεν ήταν δυνατή η φόρτωση των λεπτομερειών της προπληρωμένης κάρτας. Μπορείτε να δοκιμάσετε ξανά αργότερα.',
    'tokenCard.toast.copiedToClipboard': 'Αντιγράφηκε στο πρόχειρο!',
    'tokenCard.toast.copyManually': 'Αντιγραφή χειροκίνητα',
    'tokenCard.toast.copyManuallyDesc': 'Παρακαλώ αντιγράψτε αυτόν τον κωδικό: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Ανανέωση κατάστασης διακριτικού...',
    'tokenCard.toast.checkingActivity': 'Έλεγχος πρόσφατης δραστηριότητας',
    'tokenCard.toast.prepaidCardIssued': 'Εκδόθηκε Προπληρωμένη Κάρτα!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Το διακριτικό {{key}} έχει μετατραπεί σε προπληρωμένη κάρτα {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Κοινοποιήθηκε με επιτυχία!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Το διακριτικό κοινοποιήθηκε μέσω των επιλογών κοινοποίησης συσκευής',
    'tokenCard.toast.shareTextCopied': 'Κείμενο κοινοποίησης αντιγράφηκε!',
    'tokenCard.toast.shareTextCopiedDesc': 'Πληροφορίες κοινοποίησης διακριτικού αντιγράφηκαν στο πρόχειρο',
    'tokenCard.toast.tokenInfoCopied': 'Κείμενο κοινοποίησης αντιγράφηκε!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Πληροφορίες διακριτικού αντιγράφηκαν στο πρόχειρο',
    'tokenCard.toast.nfcPaymentReady': 'Η πληρωμή NFC είναι έτοιμη',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Κρατήστε το τηλέφωνό σας κοντά στο τερματικό πληρωμής για να ολοκληρώσετε τη συναλλαγή.',
    'tokenCard.toast.conditionsApplied': 'Οι συνθήκες εφαρμόστηκαν',
    'tokenCard.toast.conditionsAppliedDesc': 'Το διακριτικό σας έχει ενημερωθεί με τις καθορισμένες συνθήκες.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Το τιμολόγιο πληρώθηκε με επιτυχία!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Το τιμολόγιο {{key}} έχει πληρωθεί.',
    'tokenCard.toast.paymentFailed': 'Η πληρωμή απέτυχε',
    'tokenCard.toast.paymentFailedDesc': 'Αποτυχία πληρωμής τιμολογίου. Παρακαλώ δοκιμάστε ξανά.',
  },
  ro: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Eroare la încărcarea cardului prepaid',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Nu se pot încărca detaliile cardului prepaid. Puteți încerca din nou mai târziu.',
    'tokenCard.toast.copiedToClipboard': 'Copiat în clipboard!',
    'tokenCard.toast.copyManually': 'Copiază manual',
    'tokenCard.toast.copyManuallyDesc': 'Vă rugăm să copiați acest cod: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Actualizare status token...',
    'tokenCard.toast.checkingActivity': 'Verificare activitate recentă',
    'tokenCard.toast.prepaidCardIssued': 'Card Prepaid Emis!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'Tokenul {{key}} a fost convertit într-un card prepaid {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Partajat cu succes!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Tokenul a fost partajat prin opțiunile de partajare ale dispozitivului',
    'tokenCard.toast.shareTextCopied': 'Textul de partajare copiat!',
    'tokenCard.toast.shareTextCopiedDesc': 'Informațiile de partajare token copiate în clipboard',
    'tokenCard.toast.tokenInfoCopied': 'Textul de partajare copiat!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Informațiile token copiate în clipboard',
    'tokenCard.toast.nfcPaymentReady': 'Plata NFC Gata',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Țineți telefonul aproape de terminalul de plată pentru a finaliza tranzacția.',
    'tokenCard.toast.conditionsApplied': 'Condiții Aplicate',
    'tokenCard.toast.conditionsAppliedDesc': 'Tokenul dvs. a fost actualizat cu condițiile specificate.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Factura Plătită cu Succes!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'Factura {{key}} a fost plătită.',
    'tokenCard.toast.paymentFailed': 'Plata a Eșuat',
    'tokenCard.toast.paymentFailedDesc': 'Nu s-a putut plăti factura. Vă rugăm să încercați din nou.',
  },
  pt: {
    'tokenCard.toast.errorLoadingPrepaidCard': 'Erro ao carregar cartão pré-pago',
    'tokenCard.toast.errorLoadingPrepaidCardDesc': 'Não foi possível carregar os detalhes do cartão pré-pago. Você pode tentar novamente mais tarde.',
    'tokenCard.toast.copiedToClipboard': 'Copiado para a área de transferência!',
    'tokenCard.toast.copyManually': 'Copiar manualmente',
    'tokenCard.toast.copyManuallyDesc': 'Por favor, copie este código: {{text}}',
    'tokenCard.toast.refreshingStatus': 'Atualizando status do token...',
    'tokenCard.toast.checkingActivity': 'Verificando atividade recente',
    'tokenCard.toast.prepaidCardIssued': 'Cartão Pré-pago Emitido!',
    'tokenCard.toast.prepaidCardIssuedDesc': 'O token {{key}} foi convertido em um cartão pré-pago {{brand}}',
    'tokenCard.toast.sharedSuccessfully': 'Compartilhado com sucesso!',
    'tokenCard.toast.sharedSuccessfullyDesc': 'Token compartilhado via opções de compartilhamento do dispositivo',
    'tokenCard.toast.shareTextCopied': 'Texto de compartilhamento copiado!',
    'tokenCard.toast.shareTextCopiedDesc': 'Informações de compartilhamento do token copiadas para a área de transferência',
    'tokenCard.toast.tokenInfoCopied': 'Texto de compartilhamento copiado!',
    'tokenCard.toast.tokenInfoCopiedDesc': 'Informações do token copiadas para a área de transferência',
    'tokenCard.toast.nfcPaymentReady': 'Pagamento NFC Pronto',
    'tokenCard.toast.nfcPaymentReadyDesc': 'Mantenha seu telefone próximo ao terminal de pagamento para completar a transação.',
    'tokenCard.toast.conditionsApplied': 'Condições Aplicadas',
    'tokenCard.toast.conditionsAppliedDesc': 'Seu token foi atualizado com as condições especificadas.',
    'tokenCard.toast.invoicePaidSuccessfully': 'Fatura Paga com Sucesso!',
    'tokenCard.toast.invoicePaidSuccessfullyDesc': 'A fatura {{key}} foi paga.',
    'tokenCard.toast.paymentFailed': 'Pagamento Falhou',
    'tokenCard.toast.paymentFailedDesc': 'Falha ao pagar fatura. Por favor, tente novamente.',
  },
};


